import React, {useContext} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperience} from "../../portfolio";
// import {Bounce, Fade, LightSpeed, Slide, Flip,Zoom} from "react-reveal";
// import Pulse from 'react-reveal/Pulse';
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  if (workExperience.display) {
    return (
      <>
          <div id="experience" className="main">
              <h1 className="component-heading">Experience</h1>
              <div className="experience-cards-div">
                {workExperience.experience.map((card, i) => {
                  return (
                    <ExperienceCard
                      key={i}
                      isDark={isDark}
                      cardInfo={card}
                    />
                  );
                })}
              </div>
          </div>
      </>
    );
  }
  return null;
}
